'use client'

import { createContext } from 'react'
import { FormsState } from './FormProvider'

export const FormContext = createContext<{
  createForm?: (id: string) => void
  openForm?: (id: string) => void
  closeForm?: (id: string) => void
  state?: FormsState
}>({})
